import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale
} from "chart.js"

Chart.register(
  LineController,
  LineElement,
  PointElement,
  LinearScale
)

export default class extends Controller {
  static values = {
    points: Array
  }

  connect() {
    this.renderSparkline()
  }

  renderSparkline() {
    const sortedPoints = [...this.pointsValue].sort((a, b) => a.wind_speed - b.wind_speed)
    
    const ctx = this.element.getContext("2d")
    new Chart(ctx, {
      type: "line",
      data: {
        labels: sortedPoints.map(p => p.wind_speed),
        datasets: [{
          data: sortedPoints.map(p => p.power),
          borderColor: "rgb(34, 139, 34)",
          borderWidth: 1.5,
          pointRadius: 0,
          tension: 0.4,
          fill: false
        }]
      },
      options: {
        responsive: false,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false }
        },
        scales: {
          x: { display: false },
          y: { display: false }
        }
      }
    })
  }
}
